<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <add-button @click="table_addItem">{{$I18n("add_payment")}}</add-button>
          <!-- 卡片主体(表格) -->
          <md-table v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('name')">{{ item.remark }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.platform_type_name }}</md-table-cell>
              <md-table-cell :md-label="'APPID'">
                {{ (item.platform_app_id && item.platform_app_id.length) > 20 ?item.platform_app_id.slice(0,20) + "..." :item.platform_app_id }}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('platform_privateKey')">
                {{ (item.platform_private_key && item.platform_private_key.length > 20) ?item.platform_private_key.slice(0,20) + "..." :item.platform_private_key }}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button
                  @click.stop="table_editItem(item)"
                  class="md-just-icon md-round md-info left-icon"
                  ><md-icon>edit</md-icon></md-button
                >
                <md-button
                  @click.stop="table_deleteItem(item)"
                  class="md-just-icon md-round md-danger md-info"
                  ><md-icon>close</md-icon></md-button
                >
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modalTitle"
      :right = "openModalType!=='delete'"
      :large = "openModalType==='import'"
      @submit= "modal_submit"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='delete'">{{$I18n("check_delete", modalData.Form.id)}}</div>
        <!-- 修改/添加弹窗 -->
        <div v-else>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
            <file-input v-if="item.keys ==='platform_public_key_file'" :error="modalData.Error.platform_public_key" @change="changePPK">
              <md-input :style="{'width':'100%'}" v-model="modalData.Form.platform_public_key_file" readonly :placeholder="$I18n('click_select_file')"/>
            </file-input>
            <file-input v-if="item.keys ==='platform_private_key_file'" :error="modalData.Error.platform_private_key" @change="changePPK_2">
              <md-input :style="{'width':'100%'}" v-model="modalData.Form.platform_private_key_file" readonly :placeholder="$I18n('click_select_file')"/>
            </file-input>
            <file-input v-if="item.keys ==='token_prikey_file'" :error="modalData.Error.token_prikey" @change="changeTP">
              <md-input :style="{'width':'100%'}" v-model="modalData.Form.token_prikey_file" readonly :placeholder="$I18n('click_select_file')"/>
            </file-input>
          </common-form-item>
          <!-- <input :style="{display:'none'}" type="file" ref="inputFile" @change="onChange" /> -->
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass } from "@/common/tools.js";
import FileInput from "@/components/Common/FileInput.vue"
export default {
  components: {
    FileInput,
  },
  data() {
    return {
      file:"",
      // 表格相关
      ...({
        icon  : "computer",
        title : this.$I18n("payment_platform"),
        tableInitData : [], // 表格数据
        compData : [], // 公司数据
        // 分页相关
        pageSize : 10,
        currentPage : 1,
        total : 0,
        // 弹窗相关
        openModal: false,  // 是否打开弹窗
        openModalType : "upload", // 弹窗类型
        modalTitle : "",  // 弹窗标题
      }),
      // 弹窗表单相关
      ...({
        modalData : new FormClass({
          comp_id : "",
          env_type : 1,
          platform_type : 1,
          platform_app_id: "",
          platform_public_key: "",
          platform_private_key: "",
          // platform_return_url: "",
          // platform_notify_url: "",
          platform_public_key_file:"",
          platform_private_key_file:"",
          // token_prikey:"",
          // token_prikey_file:"",
          remark: "",
        },{
          platform_app_id : function(val, formVal){
            if(parseInt(formVal.platform_type) === 7){
              return false;
            } else {
              return !val
            }
          },
          platform_public_key : function(val, formVal){
            let valNum = parseInt(formVal.platform_type)
            if(valNum === 7 || valNum === 8 || valNum === 9 || valNum === 10 || valNum === 11){
              return false;
            } else {
              return !val
            }
          },
          platform_private_key : function(val){
            // let valNum = parseInt(formVal.platform_type)
            return !val
          },
          remark : "required",
        }),
      })
    };
  },
  mounted : function() {
    this.api_getPageData();
    this.api_getComp().then(() => {
      if(this.compData.length === 0){
        return
      }
      this.modalData.SetInit(this.compData[0].comp_id, "comp_id");
    });
  },
  watch: {
    currentPage() {
      this.api_getPageData();
    },
  },
  computed: {
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return [...this.tableInitData]
          .splice((this.currentPage-1) * this.pageSize, this.pageSize)
          .map(item => {
            let platform_type_name = "";
            switch(item.platform_type){
              case 1:
                platform_type_name = this.$I18n("alipay");
                break;
              case 2:
                platform_type_name = this.$I18n("wechart");
                break;
              case 3:
                platform_type_name = this.$I18n("paypal");
                break;
              case 4:
                platform_type_name = this.$I18n("comp_pay");
                break;
              case 6: 
                platform_type_name = this.$I18n("payu");
                break;
              case 7: 
                platform_type_name = this.$I18n("stripe");
                break;
              case 8: 
                platform_type_name = this.$I18n("paytm");
                break;
              case 9: 
                platform_type_name = this.$I18n("razorpay");
                break;
              case 10: 
                platform_type_name = this.$I18n("applepay");
                break;
              case 11: 
                platform_type_name = this.$I18n("googlepay");
                break;
              default:
                platform_type_name = this.$I18n("unknow_state");
                break;
            }
            return {
              platform_type_name,
              ... item,
            }
          })
      }
    },
    form_modalData(){
      let typeOtions = [];
      switch(parseInt(this.modalData.Form.platform_type)){
        case 1:
        case 4:
          typeOtions = [
            {
              label   : "APPID",
              keys    : "platform_app_id",
              type    : "input",
              required: true,
              check   : true,
            },{
              label   : this.$I18n("platform_publicKey"),
              keys    : "platform_public_key",
              type    : "input",
              required: true,
              check   : true,
            },{
              label   : this.$I18n("platform_privateKey"),
              keys    : "platform_private_key",
              type    : "input",
              required: true,
              check   : true,
            },
          ];
          break;

        case 2:
          typeOtions = [
            {
              label   : "APPID",
              keys    : "platform_app_id",
              type    : "input",
              required: true,
              check   : true,
            },{
              label   : this.$I18n("merchant"),
              keys    : "platform_public_key",
              type    : "input",
              required: true,
              check   : true,
            },{
              label   : this.$I18n("apiv2"),
              keys    : "platform_private_key",
              type    : "input",
              required: true,
              check   : true,
            },
          ];
          break;

        case 3:
          typeOtions = [
            {
              label   : "APPID",
              keys    : "platform_app_id",
              type    : "input",
              required: true,
              check   : true,
            },{
              label   : "Client ID",
              keys    : "platform_public_key",
              type    : "input",
              required: true,
              check   : true,
            },{
              label   : "Secret",
              keys    : "platform_private_key",
              type    : "input",
              required: true,
              check   : true,
            },
          ];
          break;

        case 6:
          typeOtions = [
            {
              label   : "APPID",
              keys    : "platform_app_id",
              type    : "input",
              required: true,
              check   : true,
            },{
              label   : "Sale",
              keys    : "platform_private_key",
              type    : "input",
              required: true,
              check   : true,
              disabled: this.openModalType === 'edit',
            },
          ];
          break;

        case 7:
          typeOtions = [
            {
              label   : this.$I18n("api_key"),
              keys    : "platform_private_key",
              type    : "input",
              required: true,
              check   : true,
              disabled: this.openModalType === 'edit',
            },
          ];
          break;

        case 8:
          typeOtions = [
            {
              label   : this.$I18n("merchant_id"),
              keys    : "platform_app_id",
              type    : "input",
              required: true,
              check   : true,
            },{
              label   : this.$I18n("merchant_key"),
              keys    : "platform_private_key",
              type    : "input",
              required: true,
              check   : true,
            },
          ];
          break;

        case 9:
          typeOtions = [
            {
              label   : "KEY ID",
              keys    : "platform_app_id",
              type    : "input",
              required: true,
              check   : true,
            },{
              label   : "KEY Secret",
              keys    : "platform_private_key",
              type    : "input",
              required: true,
              check   : true,
            },
          ];
          break

        case 10:
          typeOtions = [
            {
              label   : "BundleID",
              keys    : "platform_app_id",
              type    : "input",
              required: true,
              check   : true,
            // },{
            //   label   : "Apple Pay Merchant Identity Certificate",
            //   keys    : "platform_public_key",
            //   required: true,
            //   check   : true,
            //   hide    : true,
            },{
              label   : this.$I18n("password"),
              keys    : "platform_private_key",
              type    : "input",
              required: true,
              check   : true,
            },
          ];
          break;

        case 11:
          typeOtions = [
            {
              label   : this.$I18n("app_packet"),
              keys    : "platform_app_id",
              type    : "input",
              required: true,
              check   : true,
            },{
              label   : this.$I18n("secret_file"),
              keys    : "platform_private_key_file",
              type    : "file",
              required: true,
              check   : true,
            },
          ]
      }
      return [
        {
          label   : this.$I18n("name"),
          keys    : "remark",
          type    : "input",
          check   : true,
          required: true,
        },{
          label   : this.$I18n("company"),
          keys    : "comp_id",
          type    : "select",
          placeholder: this.$I18n('pls_input_role_id'),
          options : this.compData.map(i => {
            return {
              id  : i.comp_id,
              name: i.comp_name,
            }
          })
        },{
          label   : this.$I18n("platform_type"),
          keys    : "platform_type",
          type    : "select",
          options : [
            {id:"1" , name: this.$I18n("alipay")},
            {id:"2" , name: this.$I18n("wechart")},
            {id:"3" , name: this.$I18n("paypal")},
            // {id:"4" , name: this.$I18n("comp_pay")},
            // {id:"6" , name: this.$I18n("payu")},
            {id:"7" , name: this.$I18n("stripe")},
            {id:"8" , name: this.$I18n("paytm")},
            {id:"9" , name: this.$I18n("razorpay")},
            {id:"10" , name: this.$I18n("applepay")},
            {id:"11" , name: this.$I18n("googlepay")},
          ],
        },{
          label   : this.$I18n("env_type"),
          keys    : "env_type",
          type    : "radio",
          options : [
            {id:1 , name: this.$I18n("build_env")},
            {id:2 , name: this.$I18n("test_env")},
          ],
        },
        ...typeOtions,
        // {
        //   label   : this.$I18n("platform_return_url"),
        //   keys    : "platform_return_url",
        //   type    : "input",
        //   check   : true,
        //   required: true,
        // },
      ]
    },
  },
  methods: {
    // platform_private_key  token_prikey
    changePPK(value, name){
      this.modalData.Form.platform_public_key = value;
      this.modalData.Form.platform_public_key_file = name;
    },
    changePPK_2(value, name){
      this.modalData.Form.platform_private_key = value;
      this.modalData.Form.platform_private_key_file = name;
    },
    changeTP(value, name){
      this.modalData.Form.token_prikey = value;
      this.modalData.Form.token_prikey_file = name;
    },
    table_addItem(){
      this.modalTitle = this.$I18n("add");
      this.modalData.Reset();
      this.openModalType = "add";
      this.$refs.modal.open();
    },
    table_editItem(item){
      this.modalTitle = this.$I18n("edit");
      if(item.platform_type === 10){
        // console.log(item)
        item = {
          ...item,
          platform_public_key_file: item.platform_public_key,
          platform_private_key_file : item.platform_private_key,
          token_prikey_file : item.token_prikey,
        }
      } else if(item.platform_type === 11){
        item = {
          ...item,
          platform_private_key_file: item.platform_private_key,
        }
      }
      this.modalData.Update(item);
      this.openModalType = "edit";
      this.$refs.modal.open();
    },
    table_deleteItem(item){
      this.modalTitle = this.$I18n("delete");
      this.modalData.Update(item);
      this.openModalType = "delete";
      this.$refs.modal.open();
    },
    // 获取公司信息
    api_getComp (){
      //获取菜单
      return this.$api.getCompanyList({})
        .then(this.$Then(res => {
          this.compData = res.data;
        }))
        .catch(this.$Catch("", () => {
          this.compData = [];
        }))
    },
    // 获取页面信息
    api_getPageData(){
      // 获取角色
      this.$api.getPaymentSet({})
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total = res.data.length;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    // 隐藏 弹窗
    modal_classicModalHide () {
      this.$refs.modal.close();
    },
    // 提交表单
    modal_submit () {
      if (this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_input_content"));
        return;
      }
      var apiData = {
        ...this.modalData.Form,
        key_type: 1,
      }
      if(this.modalData.Form.platform_type == 11){
        apiData.key_type = 2;
      }
      let apiPOST = new Promise(() => {});
      if(this.openModalType === "add"){
        apiPOST = this.$api.addPayment(apiData)
      } else if (this.openModalType === "edit"){
        apiPOST = this.$api.editPayment(apiData)
      } else if (this.openModalType === "delete"){
        apiPOST = this.$api.delPayment(apiData)
      }
      apiPOST
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("succ_num"));
          this.modal_classicModalHide();
          this.api_getPageData();
        }))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>